import { useTranslation } from 'react-i18next';

interface SuccessScreenProps {
  textColor: string;
}

export const SuccessScreen = ({ textColor }: SuccessScreenProps) => {
  const { t } = useTranslation();

  //@ts-ignore
  const isAdmin = window.isAdminPage;

  const subscribeImageUrl = isAdmin ? '/images/newsletter.png' : '/static_assets/newsletter.png';

  return (
    <div className='w-1/2 min-[350px]:block lg:flex mx-auto'>
      <div className='flex min-[350px]:w-full lg:w-[30%] min-[350px]:mb-1 lg:mb-0'>
        <img className='m-auto w-[110px] h-[110px] rounded' src={subscribeImageUrl} alt='subscribeImage' />
      </div>
      <div className='flex justify-center min-[350px]:gap-4 lg:gap-8 flex-col min-[350px]:w-full lg:w-[70%] min-[350px]:text-center lg:text-left'>
        <h1 className='font-body min-[350px]:text-[20px] lg:text-[24px] font-semibold' style={{ color: textColor }}>
          {t('subscribeWidget.thanks')}
        </h1>
        <p className='font-body min-[350px]:text-[14px] lg:text-[16px] font-normal' style={{ color: textColor }}>
          {t('subscribeWidget.success')}
        </p>
      </div>
    </div>
  );
};
